import { __awaiter } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { loadAppDefinitions, reloadAppDefinitions, } from '../loadAppDefinitions';
let setupPromise;
export const setupM365AppsConfigService = () => {
    if (!setupPromise) {
        setupPromise = setupM365AppConfigServicePromise();
    }
    return setupPromise;
};
const setupM365AppConfigServicePromise = () => __awaiter(void 0, void 0, void 0, function* () {
    const context = yield fetchOfficeComponentContext();
    return yield ((context === null || context === void 0 ? void 0 : context.workload) == 'pwa' ||
        (context === null || context === void 0 ? void 0 : context.workload) == 'officehomereact'
        ? reloadAppDefinitions()
        : loadAppDefinitions(true));
});
//# sourceMappingURL=setupM365AppsConfigService.js.map